var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-16"},[_c('div',{staticClass:"w-full max-w-md mx-auto"},[_c('FormCreate',{attrs:{"processing":_vm.creating},on:{"submit":_vm.handleContactListCreation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }